import React, { useEffect, useRef, useState } from "react";
import { Dimensions, FlatList, Image, ImageBackground, Pressable, View } from "react-native";
import { useTheme } from "@emotion/react";
import { ODSText } from "../../../openbrix-design-system/ui/atoms/ODSText";
import getScreenType from "../../../openbrix-design-system/utils/getScreenType";
import Wrapper from "./Wrapper";
import YoutubePlayer from '../../commonComponents/youtubePlayer/youtubePlayer';
import { Typography } from "../tds/style";
import ODSButton from "../../../openbrix-design-system/ui/atoms/ODSButton/index.web";
import { COLORS } from "../../constants/colorPallete";
import { ODSInput } from "../../../openbrix-design-system/ui/atoms/ODSInput";
import { useDispatch, useSelector } from "react-redux";
import { contactUs } from "../../redux/actions/auth";
import { showToaster } from "../../redux/actions/toast";
import { getUsersCount } from "../../redux/actions/app";
import { ODSTextArea } from "../../../openbrix-design-system/ui/atoms/ODSTextArea";
const HeaderWeb = require('../../../openbrix-design-system/images/tlyfe-pages/open-web.png');
const HeaderTab = require('../../../openbrix-design-system/images/tlyfe-pages/open-tab.png');
const HeaderMobile = require('../../../openbrix-design-system/images/tlyfe-pages/open-mobile.png');
const Picture = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/tlyfepro.png');
const FooterWeb = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-web.png');
const FooterTab = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-tab.png');
const FooterMobile = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-mobile.png');
const clouds = require('../../../openbrix-design-system/images/tlyfe-pages/hangingCloud.png');
const mockVideo = require('../../../openbrix-design-system/images/tlyfe-pages/tlyfe-video-mock-mobile.png');
const profile = require('../../../openbrix-design-system/images/icons/profile.png');
const sheild = require('../../../openbrix-design-system/images/icons/sheild.png');
const pound = require('../../../openbrix-design-system/images/icons/pound.png');
const face = require('../../../openbrix-design-system/images/icons/face.png');

const bank = require('../../../openbrix-design-system/images/icons/bank.png');
const chat = require('../../../openbrix-design-system/images/icons/chat.png');
const ins = require('../../../openbrix-design-system/images/icons/ins.png');
const market = require('../../../openbrix-design-system/images/icons/market.png');
const tenantTab = require('../../../openbrix-design-system/images/tlyfe-pages/tlyfe-tab.png');
const tenantMobile = require('../../../openbrix-design-system/images/tlyfe-pages/tlyfe-mobile.png');
const tlyfeWhiteLogo = require('../../../openbrix-design-system/images/logos/tlyfe_logo_white.png');
const tlyfeBlackLogo = require('../../../openbrix-design-system/images/logos/tlyfe_rent_black.png');
const tlyfeProLogo = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/tlyfepro.png');
const cloudDivider = require('../../../openbrix-design-system/images/tlyfe-pages/clouds.png');

const multiplecheck = require('../../../openbrix-design-system/images/icons/multiplecheck.png');

const FEATURED = [

  {
    name: "Marketplace",
    desc: "Explore services tailored for tenants.",
    icon: market,
  },
  {
    name: "Credit Builder",
    desc: "Enhance your credit score as you rent.",
    icon: bank,
  },
  {
    name: "Tenant Insurance",
    desc: "Comprehensive coverage at your fingertips.",
    icon: ins,
  },
  {
    name: "Information Centre",
    desc: "Access essential resources and support.",
    icon: chat
  },
];
const tiles = [
  {
    name: "John Hards",
    title: "Chairman",
    image: require("./images/team/jh.jpg"),
  },
  {
    name: "Adam Pigott",
    title: "CEO",
    image: require("./images/team/ap.jpg"),
  },
  {
    name: "Shahad Choudhury",
    title: "CIO",
    image: require("./images/team/sh.png"),
  },
  {
    name: "Adrienne Clarke",
    title: "CFO",
    image: require("./images/team/ac.png"),
  },
  {
    name: "John William Hards",
    title: "Head of Sales",
    image: require("./images/team/jg.jpg"),
  }
];
const logo = [
  {

    image: require("./images/logo/tds.png"),
    style: { width: 110, height: 47 }
  },
  {

    image: require("./images/logo/sds.png"),
    style: { width: 110, height: 47 }
  },
  {
    image: require("./images/logo/Cl.png"),
    style: { width: 189, height: 39 }
  },
  {
    image: require("./images/logo/Inventory.png"),
    style: { width: 155, height: 39 }
  },
  {
    image: require("./images/logo/Safe.png"),
    style: { width: 114, height: 45 }
  },
  {
    image: require("./images/logo/Yoti.png"),
    style: { width: 95, height: 43 }
  },
  {
    image: require("./images/logo/Fcc.png"),
    style: { width: 166, height: 39 }
  },
  {
    image: require("./images/logo/Home.png"),
    style: { width: 166, height: 39 }
  },
  {
    image: require("./images/logo/cs.png"),
    style: { width: 166, height: 39 },
  },
  {
    image: require("./images/logo/jmi.png"),
    style: { width: 166, height: 39 },
  },
];
const BenefitItem = ({ icon, title, description }) => (
  <View style={{ marginTop: 20, flexDirection: "row" }}>
    <Image style={{ height: 30, width: 30, marginRight: 10 }} resizeMode="contain" source={icon} />
    <View style={{ flexDirection: "column", flex: 1 }}>
      <ODSText type="button">{title}</ODSText>
      <ODSText type="sm" style={{ marginTop: 14 }}>{description}</ODSText>
    </View>
  </View>
);

const WhoWeAreSection = ({ layout }) => {
  const isPhone = layout === "phone";
  const isTab = layout === "tab";
  const isCompact = isPhone || isTab;
  const contentWidth = isPhone ? "100%" : isTab ? "92%" : "86%";
  const tenantImage = isPhone ? tenantMobile : tenantTab;
  const darkText = "#162838";

  const dispatch = useDispatch();
  const userCount = useSelector((state: any) => state?.appReducer?.userCount || "350,000");

  useEffect(() => {
    dispatch(getUsersCount());
  }, [dispatch]);

  const featureCard = (icon, backgroundColor, text) => (
    <View style={{
      width: isPhone ? "88%" : isTab ? "88%" : "82%",
      maxWidth: 520,
      alignSelf: "center",
      alignItems: "center",
      backgroundColor,
      borderRadius: 12,
      paddingHorizontal: isPhone ? 22 : 34,
      paddingVertical: isPhone ? 26 : 30,
      marginTop: isPhone ? 28 : 32,
    }}>
      <View style={{
        width: 48,
        height: 48,
        borderRadius: 24,
        backgroundColor: "rgba(255,255,255,0.9)",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 16,
      }}>
        <Image source={icon} resizeMode="contain" style={{ width: 28, height: 28 }} />
      </View>
      <ODSText
        color="white"
        textAlign="center"
        type="h6"
        style={{ lineHeight: isPhone ? 28 : 32 }}
      >
        {text}
      </ODSText>
    </View>
  );

  return (
    <View style={{ width: "100%", backgroundColor: "white" }}>
      <View style={{
        alignSelf: "center",
        flexDirection: isTab ? "row" : "column",
        alignItems: "stretch",

      }}>
        <View style={{
          flex: isTab ? 1 : undefined,
          alignItems: isTab ? "flex-start" : "center",
          justifyContent: "center",
          paddingHorizontal: isPhone ? 22 : isTab ? 30 : 0,
          paddingBottom: isTab ? 20 : 30,
        }}>
          <ODSText
            color="#8E54BA"
            textAlign={isTab ? "left" : "center"}
            type={isPhone ? "h3" : "h2"}
            marginTop={30}
          >
            Who are we?
          </ODSText>
          <ODSText
            color={darkText}
            textAlign={isTab ? "left" : "center"}
            type="sm"
            marginTop={16}
            style={{
              maxWidth: isTab ? 360 : 760,
              lineHeight: 25,
            }}
          >
            At OpenBrix, we're dedicated to transforming the lettings landscape with innovative solutions that redefine the rental experience.
          </ODSText>
        </View>

        <View style={{
          flex: isTab ? 1 : undefined,
          width: isTab ? undefined : isPhone ? "100%" : "52%",
          maxWidth: 720,
          alignSelf: isTab ? "stretch" : "center",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#9D70C6",
          borderRadius: isCompact ? 0 : 12,
          paddingHorizontal: isPhone ? 28 : 40,
          paddingVertical: isPhone ? 38 : 34,
        }}>
          <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            <Image source={tlyfeWhiteLogo} resizeMode="contain" style={{ width: isPhone ? 92 : 112, height: 58 }} />
            <View style={{ width: 1, height: 54, backgroundColor: "white", marginHorizontal: 16 }} />
            <Image
              source={tlyfeProLogo}
              resizeMode="contain"
              style={{ width: isPhone ? 92 : 112, height: 58, tintColor: "white" }}
            />
          </View>
          <ODSText
            color="white"
            textAlign="center"
            type="sm"
            marginTop={20}
            style={{ maxWidth: 560, lineHeight: 25, }}
          >
            Our products, tlyfe and tlyfePRO, are designed to bring simplicity, efficiency, and transparency to tenants and agents alike.
          </ODSText>
        </View>
      </View>

      <View style={{
        width: "100%",
        flexDirection: isPhone ? "column" : "row",
      }}>
        <View style={{ flex: 0.5 }}>
          <ImageBackground
            source={tenantImage}
            resizeMode="cover"
            style={{
              width: "100%",
              height: isPhone ? 568 : isTab ? 420 : 470,
              justifyContent: isPhone ? "flex-start" : "center",
              alignItems: isPhone ? "center" : "flex-start",
            }}

          >
            <Image
              source={tlyfeBlackLogo}
              resizeMode="contain"
              style={{
                width: isPhone ? 145 : 175,
                height: 100,
                marginTop: isPhone ? 54 : 44,
                marginLeft: isPhone ? 0 : 70,
              }}
            />
          </ImageBackground>
        </View>
        <View style={{
          flex: 0.5, alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: isPhone ? 111 : 0
        }}>
          <View style={{
            width: "100%",
            paddingHorizontal: isPhone ? 23 : isTab ? 34 : 60,

          }}>
            <ODSText color={darkText} type={isPhone ? "h4" : "h3"}>
              Rent Smarter With The Tenant Lifecycle App
            </ODSText>
            <ODSText
              marginTop={18}
              color={darkText} type="sm" style={{ lineHeight: 25, }}>
              tlyfe has redefined the rental experience, making life as a tenant simpler and more efficient. As the UK’s number one tenant app, tlyfe empowers you to secure your preferred property with ease and manage your tenancy effortlessly.            </ODSText>
            {featureCard(
              profile,
              "#ED5B9D",
              `The number one tenant app with over ${userCount} active users!`
            )}
          </View>
        </View>
      </View>

      <View style={{
        height: isPhone ? 190 : 220,
        width: "100%",
        backgroundColor: "#13B3C1",
        justifyContent: "flex-end",
        marginTop: isPhone ? -8 : 0,
      }}>
        <Image
          source={cloudDivider}
          resizeMode="cover"
          style={{ width: "100%", height: isPhone ? 92 : 125 }}
        />
      </View>

      <View style={{
        width: contentWidth,
        maxWidth: 1320,
        alignSelf: "center",
        flexDirection: isPhone ? "column" : "row",
        alignItems: "center",
        paddingHorizontal: isPhone ? 23 : isTab ? 34 : 56,
        paddingTop: isPhone ? 54 : 72,
        paddingBottom: isPhone ? 64 : 82,
      }}>
        <View style={{
          width: isPhone ? "100%" : "52%",
          alignItems: "center",
          paddingRight: isPhone ? 0 : 44,
        }}>
          <Image
            source={tlyfeProLogo}
            resizeMode="contain"
            style={{ width: isPhone ? 150 : 190, height: 90, marginBottom: 24 }}
          />
          <ODSText
            color={darkText}
            textAlign={"center"}
            type={isPhone ? "h4" : "h3"}
          >
            Upgrade Your Onboarding Process
          </ODSText>
          <ODSText
            color={darkText}
            textAlign={"center"}
            type="sm"
            marginTop={18}
            style={{ lineHeight: 25 }}
          >
            tlyfePRO empowers letting agents to manage tenancies and engage with tenants through the UK’s leading tenant app, tlyfe™.
          </ODSText>
          <ODSText
            color={darkText}
            textAlign={"center"}
            type="sm"
            marginTop={18}
            style={{ lineHeight: 25 }}
          >
            From onboarding to maintenance reporting and even move out, with added portal leads. All communications come via the tlyfe app directly into your tlyfePRO dashboard.
          </ODSText>
        </View>

        <View style={{ width: isPhone ? "100%" : "48%" }}>
          {featureCard(
            sheild,
            "#20A7B5",
            "The interactive, efficient, secure and compliant option for tenant onboarding"
          )}
        </View>
      </View>
    </View>
  );
};

const TlyfeproOpenbrixLanding = () => {
  const { colors } = useTheme();
  const layout = getScreenType();

  const headerImage = layout === "web" ? HeaderWeb : layout === "tab" ? HeaderTab : HeaderMobile;

  const footerImage = layout === "web" ? FooterWeb : layout === "tab" ? FooterTab : FooterMobile;

  const cardContainerStyle = {
    borderRadius: 10,
    backgroundColor: "#fff",
    justifyContent: "center",
    alignItems: "center",
    padding: layout === "phone" ? 20 : 18,
    marginBottom: layout === "phone" ? 20 : 0,
    width: layout === "phone" ? "100%" : layout === "tab" ? "45%" : "30%",
    minWidth: layout === "phone" ? "100%" : 0,
    maxWidth: 400,
    marginHorizontal: layout === "phone" ? 0 : 10,
  };

  const heroCards = [
    {
      title: "Are you a tenant? We just moved!",
      body: "Please go to tlyfe.co.uk to register or login to your account.",
      buttonText: "Go to tlyfe.co.uk",
      themeColor: colors.main.purple,
      underlineColor: colors.main.purple["400"],
      buttonWidth: layout === "tab" ? "90%" : "80%",
      buttonMaxWidth: layout === "tab" ? 320 : 280,
      txtSize: layout === "tab" ? 14 : 16,
      onPress: () => window.open('https://www.tlyfe.co.uk/', '_blank'),
    },
    {
      title: "Are you an Agent?",
      body: "Please go to agent.openbrix.co.uk to register or login to your account.",
      buttonText: "Go to agent.openbrix.co.uk",
      themeColor: colors.main.pink,
      underlineColor: colors.main.pink["400"],
      buttonWidth: layout === "tab" ? "90%" : "80%",
      buttonMaxWidth: layout === "tab" ? 340 : 320,
      txtSize: layout === "tab" ? 13 : 16,
      onPress: () => window.open('https://agent.openbrix.co.uk/', '_blank'),
    },
    {
      title: "Request a demo",
      body: "by clicking the link below",
      buttonText: "Request a Demo",
      themeColor: colors.main.pink,
      underlineColor: colors.main.pink["400"],
      buttonWidth: layout === "tab" ? "85%" : "75%",
      buttonMaxWidth: layout === "tab" ? 300 : 260,
      txtSize: layout === "tab" ? 14 : 16,
      onPress: () => window.open('https://bookings.cloud.microsoft/bookwithme/user/a19faa222b374ef1a5abb38f8294f6cb@openbrix.co.uk?anonymous&ismsaljsauthenabled&ep=pcard', '_blank'),
    },
  ];

  const sectionStyles = layout === "phone"
    ? { flexDirection: "column", alignItems: "center", paddingHorizontal: "6%", marginBottom: 30 }
    : { flexDirection: "row", justifyContent: "center", paddingVertical: 30 };
  const windowWidth = Dimensions.get('window').width;
  const teamListRef = useRef<any>(null);
  const logoListRef = useRef<any>(null);
  const logoIndexRef = useRef(0);
  const visibleLogoCount = layout === "phone" ? 2 : layout === "tab" ? 4 : 5;
  const logoCarouselWidth = Math.min(windowWidth, 1200);
  const logoItemWidth = logoCarouselWidth / visibleLogoCount;
  const teamCarouselWidth = Math.min(windowWidth * 0.88, 430);
  const teamItemWidth = layout === "phone" ? teamCarouselWidth : 202;
  const [activeTeamIndex, setActiveTeamIndex] = useState(0);
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
  const [chekForValidate, setCheckForValidate] = useState(false);
  const validateForm = () => {
    let valid = true;
    let errors = {
      name: "",
      email: "",
      subject: "",
      message: ""
    };

    console.log("formformform", form?.name);

    if (!form?.name) {
      errors.name = "Invalid Name";
      valid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email validation regex
    if (!form?.email) {
      errors.email = "Invalid email address.";
      valid = false;
    } else if (!emailRegex.test(form.email)) {
      errors.email = "Email address is not valid.";
      valid = false;
    }

    if (!form?.subject) {
      errors.subject = "Please enter subject.";
      valid = false;
    }

    if (!form?.message) {
      errors.message = "Please enter valid message.";
      valid = false;
    }

    setErrors(errors);
    return valid;
  };

  useEffect(() => {
    if (chekForValidate) {
      validateForm()
    }
  }, [form]);

  useEffect(() => {
    logoIndexRef.current = 0;
    logoListRef.current?.scrollToOffset({ offset: 0, animated: false });

    const maxStartIndex = Math.max(logo.length - visibleLogoCount, 0);
    if (!maxStartIndex) {
      return undefined;
    }

    const interval = setInterval(() => {
      logoIndexRef.current = logoIndexRef.current >= maxStartIndex
        ? 0
        : logoIndexRef.current + 1;

      logoListRef.current?.scrollToOffset({
        offset: logoIndexRef.current * logoItemWidth,
        animated: true,
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [logoItemWidth, visibleLogoCount]);

  const moveTeamSlider = (direction) => {
    const nextIndex = direction === "next"
      ? (activeTeamIndex + 1) % tiles.length
      : (activeTeamIndex - 1 + tiles.length) % tiles.length;

    teamListRef.current?.scrollToOffset({
      offset: nextIndex * teamItemWidth,
      animated: true,
    });
    setActiveTeamIndex(nextIndex);
  };

  const dispatch = useDispatch()
  const _onSave = () => {
    setCheckForValidate(true)
    if (validateForm()) {
      dispatch(contactUs({
        email: form.email,
        topic: form.subject,
        name: form.name,
        message: form.message,
      }))
      setCheckForValidate(false)
      setForm({
        name: "",
        email: "",
        subject: "",
        message: ""
      });
      return true;
    } else {
      return false;
    }
  };

  return (
    <Wrapper
      theme={colors.transparency.blue}
      drawerColor={colors.main.blue}
      bodyStyle={{ alignSelf: "flex-start" }}
      type="login"
      headerTitle=""
      isOpenBrixLogo
      headerBody=""
      headerBlacFont
      rightImage={Picture}
      leftText={""}
      footerImage={footerImage}
      showClouds={true}
      tlyfeProMenu
    >
      <View style={{ position: "relative", backgroundColor: "#09B2C2" }}>
        <Image source={require("../../../openbrix-design-system/images/tlyfe-pages/obx.png")}
          style={{ width: 100, height: 100, marginTop: 100, alignSelf: "center" }} />
        <ODSText textAlign={"center"} marginTop={20} fontSize={36} type={"sm"} color={"#fff"} >Welcome to OpenBrix</ODSText>
        <ODSText textAlign={"center"} marginTop={20} type={'h2'} color={"#fff"}>Leading The Way In Lettings Innovation!</ODSText>
        <View style={{ ...sectionStyles, alignItems: "center" }}>
          <View
            style={layout == "phone" ? { paddingTop: 20 } : {
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'flex-start',
              alignSelf: 'center',
              width: '100%',
            }}
          >
            {heroCards.map((card, index) => {
              const isTab = layout === "tab";
              const isLastCard = index === heroCards.length - 1;
              return (
                <View
                  key={card.buttonText}
                  style={[
                    cardContainerStyle,
                    isTab && index < 2 ? { marginBottom: 18 } : null,
                    isTab && isLastCard ? { marginTop: 18 } : null,
                    layout === "phone" ? { marginBottom: 20 } : null,
                  ]}
                >
                  <ODSText type="button">{index < 2 ? "LOGIN" : "Want to know more?"}</ODSText>
                  <View style={{
                    height: 0,
                    width: index < 2 ? 50 : 160,
                    borderTopColor: card.underlineColor,
                    borderTopWidth: 3,
                    marginTop: 5
                  }} />

                  <ODSText marginTop={20} textAlign={"center"} type="h6">{card.title}</ODSText>
                  <ODSText marginTop={20} textAlign={"center"} type="sm">{card.body}</ODSText>

                  <ODSButton
                    restStyle={{
                      marginTop: index < 2 ? 20 : 40,
                      height: 40,
                      width: card.buttonWidth,
                      maxWidth: card.buttonMaxWidth,
                      alignSelf: "center",
                    }}
                    type="primary"
                    themeColor={card.themeColor}
                    txtSize={card.txtSize}
                    onPress={card.onPress}
                    disabled={false}
                  >
                    {card.buttonText}
                  </ODSButton>
                </View>
              );
            })}
          </View>
        </View>

        <WhoWeAreSection layout={layout} />

        <View style={layout === "phone" ?
          { ...sectionStyles, paddingTop: 20, backgroundColor: colors.main.purple["500"] } :
          { ...sectionStyles, backgroundColor: colors.main.purple["500"] }}>

          <View style={{ marginLeft: layout === "phone" ? "0%" : "2%", position: "relative" }}>

          </View>
          <View style={{ flexDirection: "column", width: "100%", alignItems: "center" }}>
            <ODSText
              textAlign="center"
              marginBottom={layout === "phone" ? 44 : 20}
              color="white"
              type="h3"
              fontSize={layout === "phone" ? 52 : undefined}
              style={layout === "phone" ? { lineHeight: 58, maxWidth: 300 } : undefined}
            >
              Meet the Team
            </ODSText>

            <View style={{
              width: layout === "phone" ? teamCarouselWidth : windowWidth,
              maxWidth: layout === "phone" ? 430 : 1100,
              alignSelf: "center",
              position: "relative",
            }}>
              <FlatList
                ref={teamListRef}
                data={tiles}
                horizontal
                showsHorizontalScrollIndicator={false}
                snapToInterval={layout === "phone" ? teamItemWidth : undefined}
                snapToAlignment={layout === "phone" ? "center" : "start"}
                decelerationRate={layout === "phone" ? "fast" : "normal"}
                disableIntervalMomentum={layout === "phone"}
                onMomentumScrollEnd={(event) => {
                  if (layout === "phone") {
                    setActiveTeamIndex(Math.round(
                      event.nativeEvent.contentOffset.x / teamItemWidth
                    ));
                  }
                }}
                contentContainerStyle={{
                  justifyContent: layout === "phone" ? "flex-start" : "center",
                  paddingHorizontal: layout === "phone" ? 0 : 20,
                }}
                style={{
                  width: "100%",
                  alignSelf: "center",
                }}
                renderItem={({ item, index }) => (
                  <View
                    key={index}
                    style={{
                      width: teamItemWidth,
                      alignItems: "center",
                      paddingHorizontal: layout === "phone" ? 34 : 5,
                    }}
                  >
                    <Image
                      source={item.image}
                      style={{
                        width: layout === "phone" ? teamItemWidth - 68 : 192,
                        height: layout === "phone"
                          ? (teamItemWidth - 68) * 1.25
                          : 240,
                      }}
                      resizeMode="cover"
                    />
                    <ODSText
                      marginTop={layout === "phone" ? 26 : 14}
                      color="white"
                      textAlign="center"
                      type={layout === "phone" ? "h4" : "button"}
                    >
                      {item.name}
                    </ODSText>
                    <ODSText
                      marginTop={6}
                      color="white"
                      textAlign="center"
                      type={layout === "phone" ? "h6" : "sm"}
                    >
                      {item.title}
                    </ODSText>
                  </View>
                )}
              />

              {layout === "phone" ? (
                <>
                  <Pressable
                    onPress={() => moveTeamSlider("previous")}
                    style={{
                      position: "absolute",
                      left: 0,
                      top: (teamItemWidth - 68) * 0.55,
                      width: 44,
                      height: 54,
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                    }}
                  >
                    <ODSText color="white" fontSize={52} type="sm">‹</ODSText>
                  </Pressable>
                  <Pressable
                    onPress={() => moveTeamSlider("next")}
                    style={{
                      position: "absolute",
                      right: 0,
                      top: (teamItemWidth - 68) * 0.55,
                      width: 44,
                      height: 54,
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                    }}
                  >
                    <ODSText color="white" fontSize={52} type="sm">›</ODSText>
                  </Pressable>
                </>
              ) : null}
            </View>

            {layout === "phone" ? (
              <View style={{
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 32,
                marginBottom: 24,
              }}>
                {tiles.map((_, index) => (
                  <Pressable
                    key={`team-dot-${index}`}
                    onPress={() => {
                      teamListRef.current?.scrollToOffset({
                        offset: index * teamItemWidth,
                        animated: true,
                      });
                      setActiveTeamIndex(index);
                    }}
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: 8,
                      marginHorizontal: 6,
                      backgroundColor: index === activeTeamIndex
                        ? "white"
                        : "rgba(255,255,255,0.55)",
                    }}
                  />
                ))}
              </View>
            ) : null}
          </View>
        </View>
        <View style={layout === "phone" ?
          { ...sectionStyles, paddingTop: 20, backgroundColor: "white" } :
          { ...sectionStyles, paddingVertical: 40, backgroundColor: "white" }}>
          <View style={{ flexDirection: "column", width: "100%", alignItems: "center" }}>
            <ODSText textAlign={"center"} marginBottom={30} color="black" type="h3">OpenBrix is happy to partner with</ODSText>
            <FlatList
              ref={logoListRef}
              data={logo}
              horizontal
              scrollEnabled={layout !== "web"}
              showsHorizontalScrollIndicator={false}
              snapToInterval={logoItemWidth}
              decelerationRate="fast"
              disableIntervalMomentum
              onMomentumScrollEnd={(event) => {
                logoIndexRef.current = Math.round(
                  event.nativeEvent.contentOffset.x / logoItemWidth
                );
              }}
              keyExtractor={(_, index) => `partner-logo-${index}`}
              getItemLayout={(_, index) => ({
                length: logoItemWidth,
                offset: logoItemWidth * index,
                index,
              })}
              style={{
                width: logoCarouselWidth,
                maxWidth: "100%",
                alignSelf: "center",
              }}
              contentContainerStyle={{
                alignItems: "center",
              }}
              renderItem={({ item }) => {
                const imageWidth = Math.min(item.style.width, logoItemWidth - 32);
                const imageHeight = imageWidth * (item.style.height / item.style.width);

                return (
                  <View style={{
                    width: logoItemWidth,
                    height: 84,
                    alignItems: "center",
                    justifyContent: "center",
                    paddingHorizontal: 12,
                  }}>
                    <Image
                      resizeMode="contain"
                      source={item.image}
                      style={{ width: imageWidth, height: imageHeight }}
                    />
                  </View>
                );
              }}
            />
          </View>
        </View>
        <View style={layout === "phone" ?
          { ...sectionStyles, paddingTop: 20, backgroundColor: "#09B2C2", marginBottom: 0, paddingBottom: 30 } :
          { ...sectionStyles, paddingVertical: 40, backgroundColor: "#09B2C2" }}>
          {layout == "phone" ? null : <>
            <Image
              style={layout === "phone" ? { height: 100, width: 73, position: "absolute", top: 0, right: 20 } : { height: 100, width: 73, position: "absolute", top: 0, right: 20 }}
              source={clouds}
            />
            <Image
              style={layout === "phone" ? { height: 52, width: 41, position: "absolute", top: 0, left: 40 } : { height: 52, width: 41, position: "absolute", top: 0, left: 40 }}
              source={clouds}
            />
          </>}
          <View style={layout === "phone" ? { flexDirection: "column" } : { flexDirection: "column" }}>
            <ODSText textAlign={"center"} marginBottom={30} color="white" type="h3">Contact Us</ODSText>
            <View style={layout == "web" ? { backgroundColor: colors.other['background-neutral'], borderRadius: 12, padding: 26, width: 500 } : { backgroundColor: colors.other['background-neutral'], borderRadius: 12, padding: 20, width: 340 }}>
              <ODSInput
                value={form.name}
                disabled={false}
                label={"Your name"}
                maxLength={60}
                placeholder=''
                onChange={(e) => {
                  setForm({ ...form, name: e })

                }}
                hints={errors.name ? [{ state: 'error', hint: errors.name }] : []}
              />
              <ODSInput
                value={form.email}
                disabled={false}
                label={"Your email"}
                maxLength={60}
                placeholder=''
                onChange={(e) => {
                  setForm({ ...form, email: e })

                }}
                hints={errors.email ? [{ state: 'error', hint: errors.email }] : []}
              />
              <ODSInput
                value={form.subject}
                disabled={false}
                label={"Subject"}
                maxLength={60}
                placeholder=''
                onChange={(e) => {
                  setForm({ ...form, subject: e })

                }}
                hints={errors.subject ? [{ state: 'error', hint: errors.subject }] : []}
              />
              <ODSTextArea
                value={form.message}
                disabled={false}
                label={"Message"}
                maxLength={400}
                placeholder=''
                onChange={(e) => {
                  setForm({ ...form, message: e })

                }}
                hints={errors.message ? [{ state: 'error', hint: errors.message }] : []}
              />
              <ODSButton
                restStyle={layout == "web" ? { marginTop: 20, height: 40, width: 200, alignSelf: "flex-end" } : { marginTop: 20, height: 40, }}
                type="primary"
                themeColor={colors.main.blue}
                onPress={() => _onSave()}
                disabled={false}
              >
                {'Send'}
              </ODSButton>
            </View>
          </View>
        </View>
      </View>
    </Wrapper>
  );
};

export default TlyfeproOpenbrixLanding;
